(function ($) {
  var pageSize = 10;
  var itemsLength;
  var pressWrap = $('.press-releases');
  // GIF loader
  pressWrap.before($(`<div id="press-releases-loader"><img src="/sys/images/loader.gif"></div>`));
  var loader = $('#press-releases-loader');
  var showMoreButton = {};
  var path = '/o-nas/pro-media/data.json';

  if($('body').hasClass('sk')) {
    path = '/o-nas/pre-media/data.json';
  }

  /**
   * [Nacte json  s daty.]
   * @param  {[type]} '/o-nas/pro-media/data.json' [description]
   * @param  {[type]} (data                        [description]
   * @return {[type]}                              [description]
   */
  $.getJSON(path, {}, (data) => {
    //var initPage;
    var lastPage = Math.ceil(data.items.length / pageSize);

    itemsLength = data.items.length;
    pressWrap.append('<div class="press-pagination top"></div><div class="press-items-wrap"></div><div id="load-more-news"></div><div class="press-pagination bottom"></div>');

    var paginationObjects = pressWrap.find('.press-pagination');
    setPaginations(paginationObjects, itemsLength, 1, lastPage);
    showMoreButton = $('#load-more-news');
    showMoreButton.append(renderButton());
    showPage(1, data.items, lastPage);
    $('.press-items-wrap .press-item').show();

    hideLoader(loader);


    // kliknuti na cislo
    $(document).on('click', '.press-pagination ul .page-nav', function (e) {
      var currentIndex = getIndex(e.target);

      if($(this).hasClass('active'))
        return;

      clearNews();
      setPaginations(paginationObjects, itemsLength, currentIndex, lastPage);
      showPage(currentIndex, data.items, lastPage);
    });

    // kliknuti na button "vice"
    $('#load-more-news').click( function (e) {
      //V tomto prípade je currentIndex index ďalšej stránky
      var currentIndex = getIndex(e.target);
      if(currentIndex > lastPage)
        return;

      setPaginations(paginationObjects, itemsLength, currentIndex, lastPage);
      showPage(currentIndex, data.items, lastPage);
      $('.press-items-wrap .press-item').fadeIn(150);
    });

    // kliknuti na "predchozi"
    $(document).on('click', '.press-pagination ul .prev', function (e) {
      var currentIndex = getIndex(e.target);
      if(currentIndex < 1)
        return;

      clearNews();
      showPage(currentIndex, data.items, lastPage);
      setPaginations(paginationObjects, itemsLength, currentIndex, lastPage);
    });

    // kliknuti na "nasledujici"
    $(document).on('click', '.press-pagination ul .next', function (e) {
      var currentIndex = getIndex(e.target);
      if(currentIndex > lastPage)
        return;

      clearNews();
      showPage(currentIndex, data.items, lastPage);
      setPaginations(paginationObjects, itemsLength, currentIndex, lastPage);
    });
  });

  function pressShow() {
    pressWrap.addClass('press-show');
  }

  function clearNews() {
    //Označím, ktoré novinky sa budú skrývať
    $('.press-items-wrap .press-item').addClass('old');
    //V jquery animacia skrytia - 150 ms
    $('.press-items-wrap').fadeOut(150)
    //Po animácií
    .promise().done(function() {
      $('.press-items-wrap .press-item.old').remove();
      $('.press-items-wrap .press-item').show();
      $('.press-items-wrap').fadeIn(150);
    });
  }

  function renderButton() {
    var button = $(`<button>Zobrazit více</button>`);

    return button;
  }

  function hideLoader (el) {
    el.addClass('loader-hidden');
    var timer = setTimeout(function() {
      el.remove();
      return pressShow();
    }, 151);
  }
  /**
   * [renderPress Vykresleni bloku tiskove zpravy.]
   * @param  {[type]} item [json data]
   * @return {[type]}      [description]
   */
  function renderPress (item) {
    var block = $(`<div class="press-item">`);

    $(`<div class="press-image"><img src="${item.image}"></div>`).appendTo(block);

    var text = $(`<div class="press-texts">`).appendTo(block);

    var tags = item.tag;
    var tagStr = '';
    tags.forEach(function(item) {
      tagStr += item + ', ';
    });
    var retTag = tagStr.substring(0, tagStr.length - 2);

    $(`<div class="tag"><span>${retTag}</span></div>`).appendTo(text);
    $(`<div class="title"><h3><a href="${item.url}">${item.title}</a></h3></div>`).appendTo(text);
    $(`<div class="date"><span>${item.date}</span></div>`).appendTo(text);
    $(`<div class="perex"><p>${item.perex}</p></div>`).appendTo(text);
    $(`<div class="show-more pull-right"><a href="${item.url}">Zobrazit více&nbsp;&nbsp;&nbsp;<i class="sa-icon icon-sipka-prava"></i></a></div>`).appendTo(text);
    $(`<div class="clearfix"></div>`).appendTo(block);
    return block;
  }

  function setPaginations(objects, pages, currentIndex, lastPage) {
    objects.each(function() {
      $(this).empty();
      $(this).append(renderPagination(pages, currentIndex, lastPage));
    });
  }

  /**
   * [renderPagination Vykresleni seznamu stranek.]
   * @param  {[type]} pages [pocet stranek]
   * @return {[type]}       [description]
   */
  function renderPagination (pages, currentIndex, lastPage) {
    var winWidth = (window.innerWidth < 499) ? true : false;
    //Prvé vytvorenie

    /*
    if ($('.press-pagination-wrap').length == 0)
      var wrap = $(`<div class="press-pagination-wrap">`).prependTo($('.press-releases'));
    */

    var block = $(`<div class="press-pagination text-center">`);
    var ul = $(`<ul class="pagination">`).appendTo(block);

    var isArrowActive = (currentIndex === 1) ? ' arrow-not-active' : ' arrow-is-active';
    $(`<li class="prev"><button class="icon-sipka-leva-strankovani sa-icon ${isArrowActive}" type="button"></li>`).appendTo(ul);

    if (currentIndex > 3 || ( (winWidth) && currentIndex > 2) ) {
      $(`<li class="page-nav first-page"><a>1</a></li>`).appendTo(ul);
      $(`<li class="dotted"><a>...</a></li>`).appendTo(ul);
    }

    var indexRatio;

    if(currentIndex === 1)
      indexRatio = 0;
    else if(currentIndex === 2)
      indexRatio = 1;
    else if(currentIndex === lastPage)
      indexRatio = 4;
    else if(currentIndex === lastPage - 1)
      indexRatio = 3;
    else
      indexRatio = 2;


    var i, j;
    for (i = currentIndex - indexRatio, j = 0; j < 5; i++, j++) {
      var cls = '';

      if ( (j === 0 && indexRatio === 1 && winWidth) || (j === 4 && indexRatio === 3 && winWidth) )
        cls += ' active-first';

      if (currentIndex === i)
        cls = 'active';

      $(`<li class="page-nav ${cls}"><a>${i}</a></li>`).appendTo(ul);
    }


    if (currentIndex <= (lastPage - 3) || ( (winWidth) && currentIndex <= (lastPage - 2) ) ) {
      $(`<li class="dotted"><a>...</a></li>`).appendTo(ul);
      $(`<li class="page-nav last-page"><a>${lastPage}</a></li>`).appendTo(ul);
    }

    isArrowActive = (currentIndex === lastPage) ? ' arrow-not-active' : ' arrow-is-active';
    $(`<li class="next"><button class="icon-sipka-prava-strankovani sa-icon ${isArrowActive}" type="button"></li>`).appendTo(ul);
    return block;
  }

  function getIndex (target) {
    var val;
    // ikonky s cislama
    if ($('.page-nav a').is(target))
      val = parseInt($(target).text());
    // sipka doprava + button
    else if ($('.icon-sipka-prava-strankovani').is(target) || $('#load-more-news button').is(target))
      val = parseInt($('.press-pagination:first .active').text()) + 1;
    // sipka doleva
    else
      val = parseInt($('.press-pagination:first .active').text()) - 1;

    return val;
  }

  /**
   * [showPage Funkce pro zobrazeni bloku tiskovych zprav.]
   * @param  {[type]} page [cislo bloku]
   * @return {[type]}      [description]
   */
  function showPage (page, data, lastPage) {
    var i = 0;
    data.forEach((item) => {
      i++;

      if ( (i < page * pageSize + 1) && (i > page * pageSize - pageSize ) )
        $('.press-items-wrap').append(renderPress(item).hide());
    });

    if(page >= lastPage) {
      showMoreButton.hide();
    } else if(showMoreButton.is(':hidden')) {
      showMoreButton.show();
    }

  }

})(jQuery);



// WEBPACK FOOTER //
// ./src/js/media.js